import { useGetGeneralConfig } from '@pages/employees-profile/hooks';
import { useGetCompanyPolicyData } from '@shared/hooks';
import { useState, useMemo } from 'react';

export const useCreateEmployeesProfileServicesData = () => {
  const [isParkingConfigurationEditing, setIsParkingConfigurationEditing] = useState(false);
  const [isHighwaysConfigurationEditing, setIsHighwaysConfigurationEditing] = useState(false);
  const [isPublicTransportConfigurationEditing, setIsPublicTransportConfigurationEditing] =
    useState(false);

  const { data: companyPolicyData, isLoading: isQueryLoading } = useGetCompanyPolicyData();
  const { generalConfigData, isGeneralConfigLoading } = useGetGeneralConfig();

  const availableServices = useMemo(() => {
    return generalConfigData?.availableServices.map((service) => service.type) || [];
  }, [generalConfigData]);

  const isAnyConfigurationEditing =
    isPublicTransportConfigurationEditing ||
    isHighwaysConfigurationEditing ||
    isParkingConfigurationEditing;

  return {
    availableServices,

    isParkingConfigurationEditing,
    setIsParkingConfigurationEditing,
    isHighwaysConfigurationEditing,
    setIsHighwaysConfigurationEditing,
    isPublicTransportConfigurationEditing,
    setIsPublicTransportConfigurationEditing,

    isAnyConfigurationEditing,
    isGeneralConfigLoading,
    companyPolicyData,
    isQueryLoading,
  };
};
